import { createRouter, createWebHistory } from 'vue-router'
import homeView from '../views/home-view.vue'
import certificateInfo from '../views/certificate-info.vue'

const routes = [
  {
    path: '/',
    redirect: {
      name: 'info'
    },
  },
  {
    path: '/home',
    name: 'home',
    component: homeView
  },
  {
    path: '/info',
    name: 'info',
    component: certificateInfo
  }
  // {
  //   path: '/info',
  //   name: 'info',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/certificate-info.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
